import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

export default function AlertToggleButton({ open, toggle, showLabel, hideLabel, controlsId }) {
  return (
    <ButtonWithIcon
      data-e2e={open ? 'hide-alert-description-button' : 'show-alert-description-button'}
      type="link"
      sprite={open ? 'ChevronUp' : 'ChevronDown'}
      iconRight
      aria-expanded={open}
      aria-controls={controlsId}
      onClick={toggle}
      className="alert-description--toggle-button u-els-margin-right-1o4 e2e-toggle-alert-description">
      {open ? hideLabel : showLabel}
    </ButtonWithIcon>
  );
}

AlertToggleButton.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  showLabel: PropTypes.string.isRequired,
  hideLabel: PropTypes.string.isRequired,
  controlsId: PropTypes.string.isRequired,
};
